import { useEffect, useState } from 'react';
import {
  DarwinSelect,
  StatusChip,
} from 'components/darwin-ui';
import { useTranslation } from 'react-i18next';
import {
  PROCESS_STATUSES,
  ProcessLifeCycleStatus,
  getProcessStatusConfig,
} from 'constants/process-lifecycle-status.constants';

const { Option } = DarwinSelect;

export const ChangeStatusSelect = ({
  processMapStatus,
  processMapStatusValueRef,
}: {
  processMapStatus: string;
  processMapStatusValueRef: React.MutableRefObject<string>;
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const { t } = useTranslation();

  const handleChange = (value: string) => {
    setSelectedStatus(value);
    processMapStatusValueRef.current = value;
  };

  useEffect(() => {
    if (!!processMapStatus) setSelectedStatus(processMapStatus);
  }, [processMapStatus]);

  return (
    <DarwinSelect
      value={selectedStatus}
      onChange={handleChange}
      variant="borderless"
      style={{
        width: 110,
      }}
    >
      {PROCESS_STATUSES.map(status => {
        const config = getProcessStatusConfig(status as ProcessLifeCycleStatus);
        return (
          <Option key={config.value} value={config.value}>
            <StatusChip
              label={t(config.translationKey)}
              color={config.color}
            />
          </Option>
        );
      })}
    </DarwinSelect>
  );
};
